
function Marquee() {
    return (
        <div className="marquee">
            <p>Front-end dev by day, bug fixer by night</p>
            <p>Front-end dev by day, bug fixer by night</p>
        </div>
    )
}

export default Marquee